import React from 'react';
import Badge from '@material-ui/core/Badge';
import Button from '@material-ui/core/Button';
import ListItem from '@material-ui/core/ListItem';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import { Checkbox, useEventCallback } from '@eas/common-web';
import { TreeObject } from '@models';
import { useStyles } from './local-tree-styles';
import { LocalTreeNode } from './local-tree-types';

export function LocalTreeItem<OPTION extends TreeObject>({
  disabled,
  isExpanded,
  node,
  onSelect,
  onToggle,
  selected,
}: {
  disabled?: boolean;
  isExpanded: boolean;
  node: LocalTreeNode<OPTION>;
  onSelect: (node: LocalTreeNode<OPTION>) => void;
  onToggle: (id: string) => void;
  selected: boolean;
}) {
  const classes = useStyles();
  const isLeaf = node.value.childrenCount === 0;

  const handleSelect = useEventCallback(() => {
    if (!disabled) {
      onSelect(node);
    }
  });

  const handleToggle = useEventCallback((event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    onToggle(node.id);
  });

  return (
    <ListItem
      button
      onClick={handleSelect}
      classes={{
        root: classes.item,
      }}
    >
      {!isLeaf && (
        <div>
          <Button
            size="small"
            className={classes.collapseButton}
            variant="contained"
            component="label"
            disableElevation={true}
            onClick={handleToggle}
          >
            {isExpanded ? (
              <ArrowDropDownIcon fontSize="small" />
            ) : (
              <ArrowRightIcon fontSize="small" />
            )}
          </Button>
        </div>
      )}
      <div
        className={classes.itemBody}
        style={{
          marginLeft: node.value.level * 26 + (isLeaf ? 40 : 0),
          cursor: disabled ? 'initial' : 'pointer',
        }}
      >
        <Checkbox
          value={selected}
          disabled={disabled}
          onChange={handleSelect}
        />
        {node.value.label}
        <Badge
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          classes={{
            root: classes.itemBadgeRoot,
            badge: classes.itemBadgeContent,
          }}
          badgeContent={node.value.childrenCount}
          color="primary"
        />
      </div>
    </ListItem>
  );
}
